export { envReplace } from './env-replace';
